export const enrichTheme = {
    global: {
        colors: {
            'enrich-blue': '#27516B',
            'enrich-green': '#70A193',
            'enrich-green-light': 'rgba(112, 161, 147, 0.28)',
            'enrich-green-muted': 'rgba(112, 161, 147, 0.1)',
            'enrich-accent': '#FFCA58',
            'enrich-grey': '#F5F5F5',
            'enrich-dark-grey': '#3B3B3B',
            'enrich-light-grey': '#A09EAA',
            'enrich-red': '#D1115F',
            // control: 'green',
            focus: undefined,
        },
    },
    anchor: {
        color: 'enrich-blue',
    },
    button: {
        default: {
            border: {
                radius: '10px',
            },
        },
        hover: {
            default: {
                background: { color: 'white' },
                border: { color: 'enrich-green', width: '2px' },
                color: 'enrich-green',
            },
            primary: {
                background: { color: 'enrich-green' },
                color: 'white',
            },
            secondary: {
                border: { color: 'enrich-green' },
                color: 'enrich-green',
            },
        },
        primary: {
            background: {
                color: 'enrich-blue',
            },
            border: {
                radius: '10px',
            },
        },
        secondary: {
            border: { color: 'enrich-blue', radius: '10px', width: '2px' },
            color: 'enrich-blue',
        },
        extend: () => `
            font-size: 14px;
            font-weight: 600;
        `,
    },
    tip: {
        content: {
            background: 'enrich-grey',
        },
    },
};
